import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledButtonBlack
} from "../../../styles/MyStyles";
import {GetLookupMenuItems} from "../../../logic/LookupHelper";

const BankEditPage = () => {
    const { bankId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [bank, setBank] = useState({
        name: '',
        swift: '',
        address: '',
        countryId: 1
    });

    useEffect(() => {
        const fetchBank = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (bankId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_BANKS_URL}/${bankId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        const fetchedEntities = data.data;
                        setBank(fetchedEntities);
                    } else {
                        console.log('Fetch bank failed.');
                    }
                } else {
                    setBank({
                        name: '',
                        swift: '',
                        address: '',
                        countryId: 1
                    });
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchBank();
    }, [bankId]);

    const validateForm = () => {
        let newErrors = {};

        if (!bank.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        if (!bank.swift.trim()) {
            newErrors.swift = 'Swift is required.';
        }

        if (!bank.address.trim()) {
            newErrors.address = 'Address is required.';
        }

        if (bank.countryId === '') {
            newErrors.countryId = 'Country is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setBank({
            ...bank,
            [event.target.name]: event.target.value,
        });

        setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_BANKS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(bank),
                }
            );
            if (response.ok) {
                console.log('Bank updated successfully.');
                handleGoBack();
            } else {
                console.log('Update bank failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleDelete = async () => {
        try {
            console.log(bank);
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_BANKS_URL}/${bank.id}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Bank deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete bank failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {bankId ? 'Edit Bank' : 'Create Bank'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(bankId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Name</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="name"
                                label="Name"
                                value={bank.name}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Swift</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="swift"
                                label="Swift"
                                value={bank.swift}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.swift}
                                helperText={errors.swift}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Address</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="address"
                                label="Address"
                                value={bank.address}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Country</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="countryId"
                                label="Country"
                                select
                                value={bank.countryId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.countryId}
                                helperText={errors.countryId}
                            >
                                {GetLookupMenuItems('country')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default BankEditPage;
